module.exports = __webpack_public_path__ + "img/ic_up.73bf895b.svg";